// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R5-u","question":"styles_question__sBh52","description":"styles_description__2o8aR"};